import script from "./CreateTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTicket.vue?vue&type=script&setup=true&lang=js"

import "./CreateTicket.vue?vue&type=style&index=0&id=364f77c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-364f77c4"]])

export default __exports__